<template>
    <div>
        <div v-if="isLoading" class="animate-pulse pt-10">
            <div class="h-56 w-56 rounded-lg bg-white/[0.05]"></div>
            <div class="mt-8 space-y-2">
                <div v-for="i in 5" :key="i" class="h-12 rounded-md bg-white/[0.03]"></div>
            </div>
        </div>
        <div v-else>
            <PageHeader :type="album.content_type || 'Album'" :title="album.name" :image="album.cover" :image-subtitle="album.artist?.name">
                <template #meta>
                    <span class="font-semibold text-white">{{ album.artist.name }}</span>
                    <template v-if="album.released_at"><span class="mx-1">·</span>{{ album.released_at }}</template>
                    <span class="mx-1">·</span>{{ album.songs.length }} songs
                </template>
                <template #actions v-if="album.songs && album.songs.length">
                    <button type="button" class="nl-play-fab h-14 w-14 text-xl" aria-label="Play"
                        @click="$store.dispatch('current/prepareCurrent', { id: album.songs[0].id, type: 'SONG', name: album.songs[0].name })">
                        <span class="icon-play translate-x-0.5"></span>
                    </button>
                </template>
            </PageHeader>
            <TrackList v-if="album.songs" :songs="album.songs" :artwork="false" :ad-after="[4, 24]" header />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { usePage } from "@inertiajs/vue3";
import CardSong from '@/components/CardSong.vue'
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
const page = usePage();
export default {
    created() {
        const id = usePage().props.query.id;
        this.getSignleAlbum(id);
    },
    beforeMount() {
        document.title = page.props.title
    },
    methods: {
        ...mapActions("album", ["getSignleAlbum"]),
    },
    computed: {
        ...mapState({ album: (state) => state.album.single }),
        ...mapState({ isLoading: (state) => state.album.isLoading }),
    },
    components: {
        CardSong,
        PageHeader,
        TrackList,
    }
};
</script>
